module.exports = __webpack_public_path__ + "img/5.54e9b7ab.jpg";